/** A vertical Flexbox, filling all the space (flex === 1), and providing flex to children */

import { Box, styled } from '@mui/material'

export const VBox: typeof Box = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
})) as never
